import React from 'react';

interface IconProps {
  name: string;
  size?: number;
  color?: string;
  className?: string;
}

/**
 * Composant Icon — charge un SVG FontAwesome depuis /icons/.
 * Usage : <Icon name="store" size={22} color="var(--color-primary)" />
 */
export function Icon({ name, size = 20, color = 'currentColor', className }: IconProps) {
  return (
    <img
      src={`/icons/${name}.svg`}
      alt={name}
      className={className}
      style={{
        width: size,
        height: size,
        filter: color === 'currentColor' ? undefined : svgColorFilter(color),
        display: 'inline-block',
        verticalAlign: 'middle',
      }}
    />
  );
}

// CSS filter to colorize SVG — works for simple solid icons
function svgColorFilter(color: string): string {
  // For CSS variable colors, we can't compute the filter, so use CSS mask instead
  return 'none';
}

/**
 * Version inline SVG avec mask — supporte les couleurs CSS.
 */
export function MaskIcon({ name, size = 20, color = 'currentColor', className }: IconProps) {
  return (
    <span
      className={className}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        backgroundColor: color,
        WebkitMaskImage: `url(/icons/${name}.svg)`,
        WebkitMaskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskImage: `url(/icons/${name}.svg)`,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        verticalAlign: 'middle',
      }}
    />
  );
}
